import { useState } from "react";
import { CarruselDto, CarruselTextoDto, ContenidoDto, InstitucionesDto, LineaDto, MenuDto, SubmenuDto } from "../models/Home.model";
import {
  getCarruselData,
  getCarruselTextosData,
  getContenidoData,
  getInstitucionesData,
  getMenuByIdData,
  getSubmenuByIdData,
  getTiempoData,
} from "../api/home";

export const useHome = () => {
  const [instituciones, setInstituciones] = useState<InstitucionesDto[]>([]);
  const [carruselImages, setCarruselImages] = useState<CarruselDto[]>([]);
  const [carruselText, setCarruselText] = useState<CarruselTextoDto[]>([]);
  const [lineaTiempo, setLineaTiempo] = useState<LineaDto[]>([]);
  const [timelineWidth, setTimelineWidth] = useState(0);
  const [timelineContent, setTimelineContent] = useState("");
  const [contenido, setContenido] = useState<ContenidoDto[]>([]);
  const [menu, setMenu] = useState<MenuDto[]>([]);
  const [subMenu, setSubMenu] = useState<SubmenuDto[]>([]);
  const [menuOpen, setMenuOpen] = useState<string | null>("");
  const [submenuOpen, setSubmenuOpen] = useState<string | null>("");
  const [activeIndices, setActiveIndices] = useState<number[]>([0]);

  const getWidthTimeline = (index: number) => {
    const n = lineaTiempo?.length;
    const slices = 100 / (n - 1);
    const res = slices * index;
    setTimelineWidth(res);
  };

  const getTimelineContent = (content: string) => setTimelineContent(content);

  const getCarruselTextos = async () => {
    try {
      const data = await getCarruselTextosData();
      setCarruselText(data);
    } catch (err) {
      console.warn(err);
    }
  };

  const getCarrusel = async () => {
    try {
      const data = await getCarruselData();
      setCarruselImages(data);
    } catch (err) {
      console.warn(err);
    }
  };

  const getLinea = async () => {
    try {
      const data = await getTiempoData();
 
      setTimelineContent(data[0]?.texto);
      setLineaTiempo(data);
    } catch (err) {
      console.warn(err);
    }
  };

  const getInstituciones = async () => {
    try {
      const data = await getInstitucionesData();
      setInstituciones(data);
    } catch (err) {
      console.warn(err);
    }
  };

  const getContenido = async () => {
    try {
      const data = await getContenidoData();
      setContenido(data);
    } catch (err) {
      console.warn(err)
    }
  }

  const getMenuById = async (id: string) => {
    try {
      const data = await getMenuByIdData(id);
      setMenu(data);
    } catch (err) {
      console.log(err);
    }
  };

  const getSubmenuById = async (id: string) => {
    try {
      const data = await getSubmenuByIdData(id);
      setSubMenu(data);
    } catch (err) {
      console.log(err);
    }
  };

  const handleMenuClick = (id: string) => {
    if (menuOpen === id) return setMenuOpen(null);
    getMenuById(id);
    return setMenuOpen(id); 
}



const handleSubmenuClick = (id: string) => {
    if (submenuOpen === id) return setSubmenuOpen(null);
    getSubmenuById(id);
    setSubmenuOpen(id); 
    return 
}

const numElement = (i: number) => {
  return i + 1 < 10 ? `0${i + 1}` :  i + 1;
}

const isElementActive = (i: number) => {
  return activeIndices.includes(i);
}

const toggleElementActive = (i: number) => {
  if (activeIndices.length === 0) {
      setActiveIndices([i]); 
  } else {
      const currentIndex = activeIndices[0];
      const min = Math.min(currentIndex, i);
      const max = Math.max(currentIndex, i);
      const updatedActiveIndices = Array.from({ length: max - min + 1 }, (_, index) => min + index);
      setActiveIndices(updatedActiveIndices);
  }
}

  return {
    instituciones,
    carruselText,
    carruselImages,
    lineaTiempo,
    timelineWidth,
    timelineContent,
    contenido,
    menu,
    subMenu,
    menuOpen,
    submenuOpen,
    numElement,
    isElementActive,
    toggleElementActive,
    handleMenuClick,
    handleSubmenuClick,
    getCarruselTextos,
    getCarrusel,
    getLinea,
    getContenido,
    getInstituciones,
    getTimelineContent,
    getWidthTimeline,
  };
};
